import { InviteSearchPerson } from "../types";

export const dedupeInviteSearchPersons = (
  selectedUsers: InviteSearchPerson[],
  suggestions: InviteSearchPerson[],
) => {
  const suggestionsNotChecked = suggestions.reduce((acc: InviteSearchPerson[], suggestion) => {
    if (!selectedUsers.find((user) => user.primaryCalendarId === suggestion.primaryCalendarId)) {
      acc.push(suggestion);
    }
    return acc;
  }, []);

  return [...selectedUsers, ...suggestionsNotChecked];
};
